import { Component } from '@angular/core';
import { PlansComponent } from "../plans/plans.component";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BuyBookComponent } from "../../../../buy-book/buy-book.component";

@Component({
  selector: 'app-buy-pruducts',
  imports: [
    CommonModule, PlansComponent, RouterModule,
    BuyBookComponent
],
  standalone: true,
  templateUrl: './buy-pruducts.component.html',
  styleUrl: './buy-pruducts.component.css'
})
export class BuyPruductsComponent {

}
